// import React, { useRef, useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { FaMobileAlt, FaEnvelope } from 'react-icons/fa';

// const Header = () => {
//   const navbarCollapseRef = useRef(null);
//   const mobileMenuRef = useRef(null);
//   const [dropdownOpen, setDropdownOpen] = useState({ about: false, contact: false });

//   const handleNavItemClick = () => {
//     if (navbarCollapseRef.current) {
//       navbarCollapseRef.current.classList.remove('show');
//     }
//     setDropdownOpen({ about: false, contact: false }); // Close dropdowns
//   };

//   const toggleDropdown = (menu) => {
//     setDropdownOpen((prevState) => ({
//       ...prevState,
//       [menu]: !prevState[menu]
//     }));
//   };

//   useEffect(() => {
//     const handleMobileMenuToggle = () => {
//       if (navbarCollapseRef.current) {
//         navbarCollapseRef.current.classList.toggle('show');
//       }
//     };

//     const mobileMenuIcon = mobileMenuRef.current;
//     mobileMenuIcon.addEventListener('click', handleMobileMenuToggle);

//     return () => {
//       mobileMenuIcon.removeEventListener('click', handleMobileMenuToggle);
//     };
//   }, []);

//   return (
//     <header className="main-header">
//       <div className="header-top bg-darkk">
//         <div className="inner-container bg-redd text-white py-2 text-center">
//           <div className="top-left leftt">
//             <ul className="header-info list-unstyled mb-0 d-flex flex-column flex-md-row justify-content-between">
//               <li className="d-flex align-items-center mb-3 mb-md-0 me-md-4">
//                 <div>
//                   <p className="mb-0">
//                     <div className="phone-numbers d-md-flex">
//                       <a href="tel:+919594917913" className="d-block fw-bold text-white  ">
//                         <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
//                       </a>
//                     </div>
//                   </p>
//                 </div>
//               </li>
//               <li className="d-flex align-items-center mb-3 mb-md-0 ms-md-auto text-end ">
//                 <FaEnvelope className="darkcolorrr colored me-2" />
//                 <div>
//                   <p className="mb-0">
//                     <a href="mailto:booking@shreecabs24.com" className="d-block fw-bold text-white">booking@shreecabs24.com</a>
//                   </p>
//                 </div>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       <nav className="navbar navbar-expand-lg navbar-light">
//         <div className="container">
//           <Link className="navbar-brand" to="/">
//             <img src="/images/lo0go.png" className='logoo d-block d-md-none' alt="logo" />
//             <img src="/images/lo0goo.png" className='logoo d-none d-md-block' alt="logo" />

//           </Link>
//           <button
//             className="navbar-toggler bordee"
//             type="button"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//             ref={mobileMenuRef}
//           >

//             <span className=" text-white"><i class="bi bi-list"></i></span>
//           </button>
//           <div className="collapse navbar-collapse" ref={navbarCollapseRef} id="navbarSupportedContent">
//             <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
//               <li className="nav-item">
//                 <Link className="nav-link active fw-bold" to="/" onClick={handleNavItemClick}>Home</Link>
//               </li>

//               <li className="nav-item dropdown">
//                 <Link
//                   className="nav-link dropdown-toggle active fw-bold"
//                   to="#"
//                   onClick={() => toggleDropdown('about')}
//                   data-bs-toggle="dropdown" // Necessary for Bootstrap's dropdown
//                   aria-expanded={dropdownOpen.about ? "true" : "false"}
//                 >
//                   About Us
//                 </Link>
//                 <ul className={`dropdown-menu ${dropdownOpen.about ? 'show' : ''}`}>
//                   <li><Link className="dropdown-item fw-bold" to="/about" onClick={handleNavItemClick}>About Us</Link></li>
//                   <li><Link className="dropdown-item fw-bold" to="/term-condition" onClick={handleNavItemClick}>Terms & Conditions</Link></li>
//                   <li><Link className="dropdown-item fw-bold" to="/privacy-policy" onClick={handleNavItemClick}>Privacy & Policy</Link></li>
//                 </ul>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link active fw-bold" to="/services" onClick={handleNavItemClick}>Services</Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link active fw-bold" to="/our-fleets" onClick={handleNavItemClick}>Our Fleet</Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link active fw-bold" to="/booking" onClick={handleNavItemClick}>Booking</Link>
//               </li>

//               <li className="nav-item dropdown">
//                 <Link
//                   className="nav-link dropdown-toggle active fw-bold"
//                   to="#"
//                   onClick={() => toggleDropdown('contact')}
//                   data-bs-toggle="dropdown" // Necessary for Bootstrap's dropdown
//                   aria-expanded={dropdownOpen.contact ? "true" : "false"}
//                 >
//                   Contact Us
//                 </Link>
//                 <ul className={`dropdown-menu ${dropdownOpen.contact ? 'show' : ''}`}>
//                   <li><Link className="dropdown-item fw-bold" to="/contact" onClick={handleNavItemClick}>Contact Us</Link></li>
//                   <li><Link className="dropdown-item fw-bold" to="/enquiry" onClick={handleNavItemClick}>Enquiry</Link></li>
//                 </ul>
//               </li>
//             </ul>

//             <div className="d-flex align-items-center">
//               <button
//                 className="p-3 text-white fw-bold borderrr bg-header"
//                 // style={{ backgroundColor: '#EA5628' }}
//                 onClick={() => {
//                   const message = "Hello Shree Tours and Travels, I am interested in booking a Cab. Could you please share more details at your earliest? Thank you!";
//                   const encodedMessage = encodeURIComponent(message); // Encode the message to be URL-safe
//                   const whatsappUrl = `https://wa.me/+919594917913?text=${encodedMessage}`;
//                   window.open(whatsappUrl, "_blank");
//                 }}
//               >
//                 Book Your Cab
//               </button>

//             </div>
//           </div>


//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;


import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaMobileAlt, FaEnvelope } from 'react-icons/fa';

const Header = () => {
  const navbarCollapseRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState({ about: false, contact: false });
  const [scrolling, setScrolling] = useState(false);  // State to track if scrolled

  // Handle scroll event
  const handleScroll = () => {
    const scrollPosition = window.scrollY;  // Get current scroll position
    if (scrollPosition > 100) {
      setScrolling(true);  // Activate sticky header when scrolled more than 100px
    } else {
      setScrolling(false);  // Deactivate sticky header if scrolled back up
    }
  };

  const handleNavItemClick = () => {
    if (navbarCollapseRef.current) {
      navbarCollapseRef.current.classList.remove('show');
    }
    setDropdownOpen({ about: false, contact: false });
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [menu]: !prevState[menu],
    }));
  };

  // Adding scroll event listener when component mounts
  useEffect(() => {
    const handleMobileMenuToggle = () => {
      if (navbarCollapseRef.current) {
        navbarCollapseRef.current.classList.toggle('show');
      }
    };

    const mobileMenuIcon = mobileMenuRef.current;
    mobileMenuIcon.addEventListener('click', handleMobileMenuToggle);

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      mobileMenuIcon.removeEventListener('click', handleMobileMenuToggle);
      window.removeEventListener('scroll', handleScroll);  // Clean up scroll listener
    };
  }, []);

  return (
    <header>
      {/* Header-top remains static */}
      <div className="header-top bg-darkk">
        <div className="inner-container bg-redd text-white py-2 text-center">
          <div className="top-left leftt">
            <ul className="header-info list-unstyled mb-0 d-flex flex-column flex-md-row justify-content-between">
              <li className="d-flex align-items-center mb-3 mb-md-0 me-md-4">
                <div>
                  <p className="mb-0">
                    <div className="phone-numbers d-md-flex">
                      <a href="tel:+919594917913" className="d-block fw-bold text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                    </div>
                  </p>
                </div>
              </li>
              <li className="d-flex align-items-center mb-3 mb-md-0 ms-md-auto text-end">
                <FaEnvelope className="darkcolorrr colored me-2" />
                <div>
                  <p className="mb-0">
                    <a href="mailto:booking@shreecabs24.com" className="d-block fw-bold text-white">
                      booking@shreecabs24.com
                    </a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Main header which becomes sticky */}
      <nav className={`navbar navbar-expand-lg bg-white ${scrolling ? 'sticky-header' : ''}`}>
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/lo0go.png" className="logoo d-block d-md-none" alt="logo" />
            <img src="/images/lo0goo.png" className="logoo d-none d-md-block" alt="logo" />
          </Link>
          <button
            className="navbar-toggler bordee"
            type="button"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            ref={mobileMenuRef}
          >
            <span className="text-white">
              <i className="bi bi-list"></i>
            </span>
          </button>
          <div className="collapse navbar-collapse" ref={navbarCollapseRef} id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active fw-bold" to="/" onClick={handleNavItemClick}>
                  Home
                </Link>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle active fw-bold"
                  to="#"
                  onClick={() => toggleDropdown('about')}
                  data-bs-toggle="dropdown"
                  aria-expanded={dropdownOpen.about ? 'true' : 'false'}
                >
                  About Us
                </Link>
                <ul className={`dropdown-menu ${dropdownOpen.about ? 'show' : ''}`}>
                  <li>
                    <Link className="dropdown-item fw-bold" to="/about" onClick={handleNavItemClick}>
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item fw-bold" to="/term-condition" onClick={handleNavItemClick}>
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item fw-bold" to="/privacy-policy" onClick={handleNavItemClick}>
                      Privacy & Policy
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link active fw-bold" to="/services" onClick={handleNavItemClick}>
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active fw-bold" to="/our-fleets" onClick={handleNavItemClick}>
                  Our Fleet
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active fw-bold" to="/booking" onClick={handleNavItemClick}>
                  Booking
                </Link>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle active fw-bold"
                  to="#"
                  onClick={() => toggleDropdown('contact')}
                  data-bs-toggle="dropdown"
                  aria-expanded={dropdownOpen.contact ? 'true' : 'false'}
                >
                  Contact Us
                </Link>
                <ul className={`dropdown-menu ${dropdownOpen.contact ? 'show' : ''}`}>
                  <li>
                    <Link className="dropdown-item fw-bold" to="/contact" onClick={handleNavItemClick}>
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item fw-bold" to="/enquiry" onClick={handleNavItemClick}>
                      Enquiry
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>

            <div className="d-flex align-items-center">
              <button
  className="p-3 text-white fw-bold borderrr bg-header"
  onClick={() => {
    window.location.href = "tel:+919594917913";
  }}
>
  Book Your Cab
</button>

            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
